module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socketio/client.js
// module id = 541
// module chunks = 11